import { Utilities } from "../../../utils/utilities";
import { SurveyQuestionType } from "./SurveyQuestionType";

export class SurveyQuestionData {
  index: number;

  question: string = "";
  questionType = SurveyQuestionType.TEXT;
  settings: { [key: string]: any } = {};

  constructor(index: number, data?: { [key: string]: any }) {
    this.index = index;
    if (data) {
      this.setup(data);
    }
  }

  setup(data: { [key: string]: any }) {
    if (Utilities.isValidString(data.question)) {
      this.question = data.question;
    }
    if (Utilities.isValidNumber(data.type)) {
      this.questionType = SurveyQuestionType.getType(data.type);
    }
    if (Utilities.isValidObject(data.info)) {
      this.settings = data.info;
    }
  }

  toMap(): { [key: string]: any } {
    return {
      question: this.question,
      type: this.questionType?.key ?? 0,
      info: this.settings,
    };
  }
}

